export default {
  itemContentContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    textAlign: 'justify',
    minHeight: 30,
    paddingTop: 8,
    width: '100%'
  },
  title: {
    paddingTop: 21,
    width: '100%'
  },
  subtitle: {
    paddingTop: 8,
    width: '100%'
  },
  bullets: {
    paddingTop: 6,
    width: '100%',
    textAlign: 'justify'
  }
};
